<template>
    <div
        class="relative facet-dropdown-container"
        v-click-outside="closeDropdown"
    >
        <div
            class="cursor-pointer flex flex-row items-center gap-2 flex-nowrap text-nowrap"
            :class="{
                'text-primary': dropdownOpen,
            }"
            @click="dropdownOpen ? closeDropdown() : openDropdown()"
        >
            Availability <i class="fa fa-chevron-down text-primary"></i>
        </div>
        <div
            class="absolute top-10 -left-1/2 w-96 overflow-x-auto bg-white rounded shadow-md p-9 flex flex-col gap-6 facet-dropdown"
            v-show="dropdownOpen"
        >
            <div class="flex flex-row gap-4 justify-between items-center">
                <div class="flex flex-row gap-4">
                    <button class="" @click="showSearch = !showSearch">
                        <i class="far text-f5 fa-search"></i>
                    </button>
                    <div class="text-primary">|</div>
                    <div
                        class="text-f6 cursor-pointer"
                        @click="resetAvailabilityFilter()"
                    >
                        Reset
                    </div>
                </div>
                <button>
                    <i
                        class="far fa-times text-primary text-f5"
                        @click="closeDropdown()"
                    ></i>
                </button>
            </div>

            <div class="w-full relative" v-if="showSearch">
                <input
                    type="text"
                    class="!px-5 !py-3 w-full bg-grey-50 rounded-s"
                    placeholder="Search..."
                    v-model="searchTerm"
                />

                <button class="absolute right-4 top-1/2 -translate-y-1/2">
                    <i class="far fa-search"></i>
                </button>
            </div>

            <div
                class="max-h-60 h-auto overflow-y-auto flex flex-col gap-3 facet-search-scroll"
            >
                <label class="sui-multi-checkbox-facet__option-label">
                    <div class="flex flex-row gap-2 items-center">
                        <input
                            class="sui-multi-checkbox-facet__checkbox"
                            type="checkbox"
                            :checked="checked"
                            @change="$emit('change', $event)"
                        />
                        <span class="text-f6"
                            >Only show products in stock
                        </span>
                    </div>
                </label>
            </div>
        </div>
    </div>
</template>

<script>
import { vClickOutside } from "../../directives/v-click-outside";

export default {
    directives: {
        clickOutside: vClickOutside,
    },
    props: {
        checked: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            dropdownOpen: false,
            searchTerm: "",
            showSearch: false,
        };
    },
    computed: {
        filteredFacetItems() {
            // Dynamically filter facet items based on the search term
            return this.facet.data.filter((item) => {
                if (this.facet.type === "range") {
                    return item.value.name
                        .toLowerCase()
                        .includes(this.searchTerm.toLowerCase());
                } else {
                    return item.value
                        .toLowerCase()
                        .includes(this.searchTerm.toLowerCase());
                }
            });
        },
    },
    methods: {
        openDropdown() {
            this.dropdownOpen = true;
        },
        closeDropdown() {
            this.dropdownOpen = false;
        },
        resetAvailabilityFilter() {
            this.checked = false;
            this.$emit("change", null);
        },
    },
};
</script>
